import React from 'react';
import { computeLabel, ControlProps, ControlState } from '@jsonforms/core';
import { Control } from '@jsonforms/react';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

export interface WithInput {
  input: any;
}

export abstract class MaterialInputControl extends Control<
  ControlProps & WithInput,
  ControlState
> {
  render() {
    const {
      id,
      description,
      errors,
      label,
      uischema,
      visible,
      required,
      config,
      input,
      enabled,
      data,
    } = this.props;

    const appliedUiSchemaOptions = { ...config, ...uischema.options };
    const hideLabel = appliedUiSchemaOptions.hideLabel;
    const newErrors =
      !data &&
      required &&
      !errors &&
      errors?.length === 0 &&
      appliedUiSchemaOptions.errorMessage &&
      enabled
        ? appliedUiSchemaOptions.errorMessage
        : errors;

    const isValid = !newErrors && newErrors?.length === 0;
    const InnerComponent = input;

    return (
      visible && (
        <FormControl
          fullWidth={!appliedUiSchemaOptions.trim}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          id={id}
          // variant="outlined"
          className={`${required ? 'required' : ''} ${
            required && !data && enabled ? 'errorRequired' : ''
          }`}
        >
          {label && !hideLabel && (
            <InputLabel
              htmlFor={`${id}-input`}
              sx={{
                width: '100%',
                textAlign: 'left',
                display: 'block',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
            >
              {computeLabel(
                typeof label === 'string' ? label : String(label),
                required || false,
                appliedUiSchemaOptions.hideRequiredAsterisk,
              )}
            </InputLabel>
          )}
          <InnerComponent
            {...this.props}
            label={hideLabel ? '' : label}
            id={`${id}-input`}
            isValid={isValid}
            visible={visible}
            errors={newErrors}
          />
          <FormHelperText>{description ? description : ''}</FormHelperText>
        </FormControl>
      )
    );
  }
}
